import { get_error_message } from "./messages";
import Vue from "vue";
import store from "../store";

var ENDPOINTS = {
  sign_up: "authentication/sign_up",
  confirm_sign_up: "authentication/confirm_sign_up",
  sign_in: "authentication/sign_in",
  get_user: "authentication/get_user",
  forgot_password: "authentication/forgot_password",
  confirm_forgot_password: "authentication/confirm_forgot_password",
  resend_verification_code: "authentication/resend_verification_code"
};

// Main auth class that keep all informations about the user
export class Auth {
  // Initialize class with a link to a config file with  in a format
  constructor(config) {
    this.config = config;
    this.api_url = config.api_url;
    this.stage = config.stage;
    this.session = null;
  }
  get_endpoint(name) {
    return `${this.api_url}/${this.stage}/${ENDPOINTS[name]}/`;
  }

  // return currently authenticated user
  async get_current_user_data() {
    if (!this.session) {
      this.session = store.state.user;
    }
    var endpoint = this.get_endpoint("get_user");
    var data = {
      access_token: this.session.access_token
    };
    var get_data = {
      method: "POST",
      url: endpoint,
      data: data
    };
    let current_user = await Vue.axios(get_data);
    let user_data = current_user.data.user_attributes;
    for (let key in user_data) {
      // cast string with boolean to actual boolean to avoid weird bugs
      if (["true", "false"].includes(user_data[key])) {
        user_data[key] = user_data[key] === "true";
      }
      // copy custom attributes with "custom:" prefix stripped
      if (key.startsWith("custom:")) {
        user_data[key.slice("custom:".length)] = user_data[key];
      }
    }
    return user_data;
  }

  // return True if user is authenticated false otherwise
  get is_authenticated() {
    if (this.session || store.state.user.refresh_token != "undefined") {
      return true;
    } else {
      return false;
    }
  }

  async sign_up(data, success_callback, failure_callback) {
    var endpoint = this.get_endpoint("sign_up");
    var get_data = {
      method: "POST",
      url: endpoint,
      data: data
    };
    let result = await Vue.axios(get_data);
    if (result.data["success"]) {
      success_callback(result);
    } else {
      failure_callback(get_error_message(result.data));
    }
  }

  // confirm registration
  async confirm_sign_up(data, success_callback, failure_callback) {
    var endpoint = this.get_endpoint("confirm_sign_up");
    var get_data = {
      method: "POST",
      url: endpoint,
      data: data
    };
    let result = await Vue.axios(get_data);
    if (result.data["success"]) {
      success_callback(result);
    } else {
      failure_callback(get_error_message(result.data));
    }
  }

  // Authenticate user in AWS Cognito using username and password
  async sign_in(data, success_callback, failure_callback) {
    var endpoint = this.get_endpoint("sign_in");
    var get_data = {
      method: "POST",
      url: endpoint,
      data: data
    };
    let result = await Vue.axios(get_data);
    if (result.data["success"]) {
      this.session = result.data.data;
      success_callback(result);
    } else {
      failure_callback(get_error_message(result.data));
    }
  }

  //forgot password
  async forgot_password(data, success_callback, failure_callback) {
    var endpoint = this.get_endpoint("forgot_password");
    var get_data = {
      method: "POST",
      url: endpoint,
      data: data
    };
    let result = await Vue.axios(get_data);
    if (result.data["success"]) {
      success_callback(result);
    } else {
      failure_callback(get_error_message(result.data));
    }
  }

  //password confirm
  async confirm_password(data, success_callback, failure_callback) {
    var endpoint = this.get_endpoint("confirm_forgot_password");
    var get_data = {
      method: "POST",
      url: endpoint,
      data: data
    };
    let result = await Vue.axios(get_data);
    if (result.data["success"]) {
      success_callback(result);
    } else {
      failure_callback(get_error_message(result.data));
    }
  }

  //resend verification code
  async resend_verification_code(data, success_callback, failure_callback) {
    var endpoint = this.get_endpoint("resend_verification_code");
    var get_data = {
      method: "POST",
      url: endpoint,
      data: data
    };
    let result = await Vue.axios(get_data);
    if (!result.data["success"]) {
      failure_callback(get_error_message(result.data));
    } else {
      success_callback(result.data);
    }
  }
}
